export default class PageInfoDto {
    public title:string;
    public description:string;
}